<template>
  <div>
    <el-dialog width="55%" :visible.sync="checkedMealTimeBoxState">
      <add-product-dialog :resourceObj="resourceObj" :productObj="productObj" :chenckBudgteObj="chenckBudgteObj" :keyStr="keyStr" 
        @closeDialog="closeDialog" ref="addProductDialog" @addBudget="addBudget">
        <template v-slot:addProductRightDiv>
          <div class="right">
            <div v-for="(item,index) in times" :key="index">
              <span class="rightTop">
                <el-checkbox :indeterminate="item.isIndeterminate" v-model="item.checkAll" @change="handleCheckAllChange(item)">全选</el-checkbox>
                {{item.name}}用餐城市
              </span>
              <el-checkbox-group v-model="item.checkList">
                <div v-for="(item1,index1) in item.planDays" :key="index1" class="dayList">
                  <el-checkbox :label="item1.planDay" @change="handleCheckChange(item)">
                    <el-input v-model="item1.cityName" placeholder="请选择最终需要用餐的城市名称" size="small"></el-input>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
            </div>
          </div>
        </template>
      </add-product-dialog>
    </el-dialog>
  </div>
</template>

<script>
import addProductDialog from './addProductDialog.vue'
import {addProductMixin} from './addProductMixin'
export default {
  components: { addProductDialog },
  mixins:[addProductMixin],
  data(){
    return{
      times:[
        {
          name:'早餐',
          isIndeterminate:false,
          checkAll:false,
          checkList:[],
        },{
          name:'午餐',
          isIndeterminate:false,
          checkAll:false,
          checkList:[],
        },
        {
          name:'晚餐',
          isIndeterminate:false,
          checkAll:false,
          checkList:[],
        }
      ]
    }
  },
  methods:{
    handleCheckAllChange(item){
      if(item.checkAll){
        item.planDays.forEach(element => {
          item.checkList.push(element.planDay)
        });
      }else{
        item.checkList=[]
      }
    },
    handleCheckChange(item){
      if(item.checkList.length==item.planDays.length){
        item.checkAll = true
        item.isIndeterminate=false
      }else if(item.checkList.length==0){
        item.checkAll = false
        item.isIndeterminate=false
      }else{
        item.isIndeterminate=true
      }
    },
    openDialog(item,item2,chenckBudgteObj,keyStr){
      this.beforeOpenDialog(item,item2,chenckBudgteObj,keyStr)
      this.times.forEach(t=>{
        t.isIndeterminate=false
        t.checkAll=false
        t.checkList=[]
        var planDayObj = JSON.parse(JSON.stringify(this.chenckBudgteObj.planDayList))
        planDayObj.forEach(element => {
          if(element.cityList.length>0){
            var cityList = []
            element.cityList.forEach(e=>{
              var list = this.resourceObj.customProductAreas.filter(c=>c.pid==e.cityId&&c.type==1)
              if(list.length==0) list = this.resourceObj.customProductAreas.filter(c=>c.pid==e.countryId&&c.type===0)
              if(list.length>0){
                cityList.push(e)
              }
            }) 
            var e 
            if(cityList.length==1){
              var e= cityList[0]
            }else if(cityList.length>1){
              if(t.name=='早餐'){
                e= cityList[0]
              }else if(t.name=='午餐'){
                if(cityList.length==2){
                  e= cityList[0]
                }else{
                  e= cityList[1]
                }
              }else{
                e= cityList[cityList.length-1]
              }
            }   
            if(e){
              this.$set(element,'cityId',e.cityId)
              this.$set(element,'cityName',e.cityName)
              this.$set(element,'cityNameEn',e.cityNameEn)   
            }
          }
        });
        this.$set(t,'planDays',planDayObj)
      })
    },
    addBudget(){
      var dateList = []
      this.times.forEach(time=>{
        time.checkList.forEach(e=>{
          var planObj = time.planDays.find(p=>p.planDay==e)
          dateList.push({
            cityId:planObj.cityId,
            cityName:planObj.cityName,
            cityNameEn:planObj.cityNameEn,
            planDate:planObj.planDate,
            timeType:time.name,
          })
        })
      })
      this.$refs.addProductDialog.postAddBudget(dateList)
    }
  }
}
</script>

<style lang="scss" scoped>
.right{
  display: flex;
  >div{
    margin-right: 0.1rem;
  }
}
.dayList{
  height: 0.32rem;
  margin-top: 0.1rem;
}
</style>